<div
  class="pip-placeholder fx-column fx-align-center fx-justify-center"
  [class.pip-placeholder-custom-color]="isCustomFontColor()"
  role="status"
>
  <av-icon name="pip-desktop" class="pip-placeholder-illustration"></av-icon>
  <h2 translate>Your call is in another window</h2>
  <p translate>
    Picture-in-picture lets you stay in the call while you do other things.
  </p>
  <button
    avButton
    ofType="stroked"
    (click)="bringBack()"
    data-tid="pip-placeholder/bring-back"
    translate
  >
    Bring the call back here
  </button>
</div>
